module.exports = __webpack_public_path__ + "img/toondetail_banner.c659e492.jpg";